import { render, staticRenderFns } from "./server-unavailable-dialog.vue?vue&type=template&id=71cbb611&scoped=true&"
import script from "./server-unavailable-dialog.vue?vue&type=script&lang=js&"
export * from "./server-unavailable-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cbb611",
  null
  
)

export default component.exports